function getSchemaName(path) {
  return path
    .split("&")[0]
    .split("/")
    .map(seg => seg.split(".")[0])
    .join("/");
}

export default getSchemaName;
